export default __webpack_public_path__ + "static/media/pantalla_pagos_callejeritos.b9e07655.png";